module.exports = __webpack_public_path__ + "img/icon-video.455e7c12.png";